import ApiAuth from '../services/ApiAuth';
import {
    CHANGE_LOGIN_DATA,
    LOGIN_ERROR,
    LOGIN_FROM_TOKEN_ERROR,
    LOGIN_START,
    LOGIN_SUCCESS,
    LOGOUT
} from './actionTypes';

export const login = (data) => ({
    async: true,
    errorType: LOGIN_ERROR,
    promise: () => ApiAuth.login(data),
    startType: LOGIN_START,
    successType: LOGIN_SUCCESS,
    type: '',
});

export const loginFromToken = (authData) => ({
    async: true,
    errorType: LOGIN_FROM_TOKEN_ERROR,
    promise: () => ApiAuth.loginFromToken(authData),
    startType: LOGIN_START,
    successType: LOGIN_SUCCESS,
    type: '',
});

export const logout = () => ({
    type: LOGOUT,
});

export const changeLoginData = (field, data) => ({
    payload: {
        field,
        data,
    },
    type: CHANGE_LOGIN_DATA,
});



// WEBPACK FOOTER //
// ./src/actions/authActions.js